import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Table, Form } from 'antd-v5';
import PageHeaderLayout from '../../component/page-header-layout';
import './index.less';
import {
  requestJobLogList,
} from '../../state/request/jobInfo';
import dayjs from 'dayjs';

const { Item } = Form;

export const JOB_STATUS = {
  NORMAL: 'NORMAL',
  NONE: 'NONE',
};

const TimedTaskLog = (props) => {
  const [form] = Form.useForm();
  const [list, setList] = useState([]);
  const [searchParams, setSearchParams] = useState({});
  const pageRef = useRef({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });

  const getData = useCallback(async () => {
    const res = await requestJobLogList({
      pageNo: pageRef.current.pageNo,
      pageSize: pageRef.current.pageSize,
      ...searchParams,
    });
    if (res.code === 200) {
      pageRef.current.total = res.data?.totalSize || 0;
      setList(res.data?.pageList || []);
    }
  }, [searchParams]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = [
    {
      title: '调度开始时间',
      dataIndex: 'startTime',
      render: (text) => {
        return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-';
      },
    },
    {
      title: '调度结束时间',
      dataIndex: 'endTime',
      render: (text) => {
        return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-';
      },
    },
    {
      title: '任务分组',
      dataIndex: 'jobGroup',
    },
    {
      title: '调度-结果编码',
      dataIndex: 'triggerCode',
    },
    {
      title: '调度-结果',
      dataIndex: 'triggerMsg',
      render: (text) => {
        return text !== 'null' ? text : '--';
      },
    },
  ];

  const onSearchFinish = (values) => {
    pageRef.current.pageNo = 1;
    setSearchParams(values);
  };

  return (
    <PageHeaderLayout>
      <div className='timed-task-management'>
        {/* <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Form layout='inline' className='header' onFinish={onSearchFinish}>
            <Item label='任务描述' name='description'>
              <Input placeholder='搜索任务描述' />
            </Item>
            <Button type='primary' htmlType='submit'>
              查询
            </Button>
          </Form>
        </div> */}

        <Table
          dataSource={list}
          columns={columns}
          pagination={{
            total: pageRef.current.total,
            pageSize: pageRef.current.pageSize,
            current: pageRef.current.pageNo,
            onChange: (page) => {
              pageRef.current.pageNo = page;
              getData();
            },
            showSizeChanger: false,
          }}
        />
      </div>
    </PageHeaderLayout>
  );
};

export default TimedTaskLog;
